import { defineMessages } from 'react-intl';

/** The copy of "Review MUSIC24" (design review-form a1-a11). */
export const reviewMessages = defineMessages({
  title: { id: 'app.sml.review.title', defaultMessage: 'Review MUSIC24' },
  subtitle: {
    id: 'app.sml.review.subtitle',
    defaultMessage:
      'Tell other artists what MUSIC24 does for your music. Real reviews from real users only. Your review can appear on music24reviews.com.',
  },
  menuItem: { id: 'app.sml.review.menuItem', defaultMessage: 'Review MUSIC24' },
  ratingLabel: { id: 'app.sml.review.rating.label', defaultMessage: 'Your rating' },
  ratingStar: {
    id: 'app.sml.review.rating.star',
    defaultMessage: '{count, plural, one {# star} other {# stars}}',
  },
  ratingMissing: { id: 'app.sml.review.rating.missing', defaultMessage: 'Pick a rating from 1 to 5 stars.' },
  nameLabel: { id: 'app.sml.review.name.label', defaultMessage: 'Your name' },
  nameHint: { id: 'app.sml.review.name.hint', defaultMessage: 'This name shows with your review.' },
  nameMissing: { id: 'app.sml.review.name.missing', defaultMessage: 'Add your name.' },
  nameTooLong: { id: 'app.sml.review.name.tooLong', defaultMessage: 'Use {max} characters or fewer.' },
  roleLabel: { id: 'app.sml.review.role.label', defaultMessage: 'You are' },
  roleArtist: { id: 'app.sml.review.role.artist', defaultMessage: 'Artist' },
  roleManager: { id: 'app.sml.review.role.manager', defaultMessage: 'Manager' },
  roleLabelCompany: { id: 'app.sml.review.role.label_company', defaultMessage: 'Label' },
  roleOther: { id: 'app.sml.review.role.other', defaultMessage: 'Other' },
  titleLabel: { id: 'app.sml.review.titleField.label', defaultMessage: 'Title' },
  titleOptional: { id: 'app.sml.review.titleField.optional', defaultMessage: '(optional)' },
  titlePlaceholder: { id: 'app.sml.review.titleField.placeholder', defaultMessage: 'Sum it up in a few words' },
  titleTooLong: { id: 'app.sml.review.titleField.tooLong', defaultMessage: 'Use {max} characters or fewer.' },
  bodyLabel: { id: 'app.sml.review.body.label', defaultMessage: 'Your review' },
  bodyPlaceholder: {
    id: 'app.sml.review.body.placeholder',
    defaultMessage: 'What does MUSIC24 do for you? What changed since you started?',
  },
  bodyHint: { id: 'app.sml.review.body.hint', defaultMessage: 'At least {min} characters.' },
  bodyCounter: { id: 'app.sml.review.body.counter', defaultMessage: '{count} / {max}' },
  bodyTooShort: {
    id: 'app.sml.review.body.tooShort',
    defaultMessage:
      'Write at least {min} characters. {missing, plural, one {# more character to go.} other {# more characters to go.}}',
  },
  bodyTooLong: { id: 'app.sml.review.body.tooLong', defaultMessage: 'Use {max} characters or fewer.' },
  consentLabel: {
    id: 'app.sml.review.consent.label',
    defaultMessage: 'Music24 may publish this review with my name on music24reviews.com and music24.com',
  },
  consentMissing: {
    id: 'app.sml.review.consent.missing',
    defaultMessage: 'Tick the box so MUSIC24 can publish your review.',
  },
  send: { id: 'app.sml.review.send', defaultMessage: 'Send review' },
  saveChanges: { id: 'app.sml.review.saveChanges', defaultMessage: 'Save changes' },
  sendAgain: { id: 'app.sml.review.sendAgain', defaultMessage: 'Send again' },
  sending: { id: 'app.sml.review.sending', defaultMessage: 'Sending…' },
  teamChecks: { id: 'app.sml.review.teamChecks', defaultMessage: 'The team reads each review before it goes live.' },
  sendFailedTitle: { id: 'app.sml.review.sendFailed.title', defaultMessage: 'We could not send your review.' },
  sendFailedBody: { id: 'app.sml.review.sendFailed.body', defaultMessage: 'Nothing changed. Try again in a moment.' },
  sendRefusedBody: {
    id: 'app.sml.review.sendRefused.body',
    defaultMessage: 'Check the fields and try again.',
  },
  statusInReview: { id: 'app.sml.review.status.inReview', defaultMessage: 'In review' },
  statusPublished: { id: 'app.sml.review.status.published', defaultMessage: 'Published' },
  statusNotPublished: { id: 'app.sml.review.status.notPublished', defaultMessage: 'Not published' },
  statusInReviewLine: {
    id: 'app.sml.review.status.inReview.line',
    defaultMessage: 'Sent on {date}. The team checks it soon.',
  },
  statusPublishedLine: {
    id: 'app.sml.review.status.published.line',
    defaultMessage: 'Live on music24reviews.com since {date}.',
  },
  publishedEditNote: {
    id: 'app.sml.review.status.published.editNote',
    defaultMessage:
      'If you save a change, your review goes back to the team. It stays off the site until the team publishes it again.',
  },
  notPublishedNote: {
    id: 'app.sml.review.status.notPublished.note',
    defaultMessage: 'The team did not publish this review. You can change it and send it again.',
  },
  thanksTitle: { id: 'app.sml.review.thanks.title', defaultMessage: 'Thank you for your review' },
  thanksBody: {
    id: 'app.sml.review.thanks.body',
    defaultMessage:
      'The MUSIC24 team reads each review before it goes live. When we publish it, it shows on music24reviews.com with your name.',
  },
  thanksEdit: { id: 'app.sml.review.thanks.edit', defaultMessage: 'Edit my review' },
  thanksHome: { id: 'app.sml.review.thanks.home', defaultMessage: 'Back to Home' },
  thanksTrustpilot: { id: 'app.sml.review.thanks.trustpilot', defaultMessage: 'Rate us on Trustpilot' },
});
